import React from 'react';
import ContactUsButton from '../components/ContactUsButton';

const SportingEventsRulesPage: React.FC = () => {
  return (
    <div className="page-container">
      <div className="services-page">
        <div className="services-container">
          <p className="breadcrumb">Services / Sporting Events</p>
          <h1 className="page-title">Sporting Events</h1>
          <p className="page-subtitle">
            Guidelines and information for hosting tournaments and sporting events at TDS Event Center.
          </p>
          <div className="page-header-actions">
            <ContactUsButton
              buttonText="Click here to ask questions"
              className="contact-button contact-button-alt"
              defaultService="Sporting Events"
              defaultInquiry="information"
            />
          </div>

          <div className="rules-section">
            <h2>Facility Usage</h2>
            <ul>
              <li>Sporting event reservations include access to designated courts, fields, or gym space.</li>
              <li>Warm-up and cool-down times must be included in the reservation window.</li>
              <li>Only approved sports and equipment are permitted on the surfaces.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>Teams &amp; Participants</h2>
            <ul>
              <li>Team rosters and schedules should be provided prior to the event, when possible.</li>
              <li>All participants must follow posted safety and conduct guidelines.</li>
              <li>Minors must be supervised by coaches or responsible adults at all times.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>Equipment &amp; Setup</h2>
            <ul>
              <li>Any special equipment or field markings must be approved in advance.</li>
              <li>Only non-marking shoes are allowed on indoor courts.</li>
              <li>All equipment must be removed or stored according to facility staff instructions.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>General Policies</h2>
            <ul>
              <li>Events must end at the scheduled time to allow for cleanup and turnover.</li>
              <li>Spectators must remain in designated viewing areas.</li>
              <li>Food and drink policies vary by space and will be reviewed during booking.</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SportingEventsRulesPage;


